import { createTheme, MantineColorsTuple } from "@mantine/core";

const kizBlue: MantineColorsTuple = [
  "#e1f5fe",
  "#b3e5fc",
  "#81d4fa",
  "#4fc3f7",
  "#29b6f6",
  "#03a9f4",
  "#039be5",
  "#0288d1",
  "#0277bd",
  "#01579b",
];

export const kizTheme = createTheme({
  primaryColor: "kizBlue",
  colors: { kizBlue },
  defaultRadius: "md",
  // Mantine's own controls (inputs, selects, its Button) are UI chrome, so they
  // take the ui face. Reading text never comes from here: `html, body` in
  // application.css sets --font-text and every <p>/<Text> inherits it.
  fontFamily: "var(--font-ui)",
  headings: {
    fontFamily: "var(--font-ui)",
    fontWeight: "800",
  },
  primaryShades: { light: 3, dark: 4 },
  components: {
    Button: {
      defaultProps: { radius: "md" },
    },
    TextInput: {
      styles: {
        input: {
          backgroundColor: "rgba(255,255,255,0.05)",
          borderColor: "rgba(255,255,255,0.15)",
          color: "#fff",
        },
      },
    },
    Select: {
      styles: {
        input: {
          backgroundColor: "rgba(255,255,255,0.05)",
          borderColor: "rgba(255,255,255,0.15)",
          color: "#fff",
        },
      },
    },
    Card: {
      defaultProps: {
        radius: "lg",
      },
    },
    Notification: {
      styles: {
        root: {
          backgroundColor: "#111d2b",
          border: "1px solid rgba(79,195,247,0.25)",
        },
        title: {
          color: "#ffffff",
          fontWeight: 600,
        },
        description: {
          color: "rgba(255,255,255,0.80)",
        },
      },
    },
  },
});
